import {inject, Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IStorageItem } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
    private http = inject(HttpClient);
    constructor() {}

    public getDocumentInfo(storageItem: IStorageItem, document: any): Observable<any> {
        const url = environment.searchUrl;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+storageItem.idToken,
            'clientId': storageItem.clientId,
        });
        return this.http.post<any>(url, document, {headers});
    }
}
